import React, { memo, useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import CourseSidebar from './CourseSidebar';
import CourseItemGrid from './CourseItemsGrid';
import { useRouter } from 'next/router';
import Loader from '@/components/common/Spinner';
import { Skeleton } from 'antd';
import { useSelector } from 'react-redux';
import useWidth from '@/helpers/widthUtil';

const CourseGrid = () => {
  const router = useRouter();
  const { isMobile, isGalaxyZFold } = useWidth();

  const [courseSummary, setCourseSummary] = useState({});

  const { courseLoading, total, summary } = useSelector((state: any) => ({
    courseLoading: state?.courses?.course?.loading,
    total: state?.courses?.course?.meta?.total,
    summary: state?.courses?.course?.summary,
  }));

  const [searchDrawer, setSearchDrawer] = useState(false);

  useEffect(() => {
    setCourseSummary(summary);
    return () => {
      setSearchDrawer(false);
    };
  }, []);

  return (
    <div className={`main-wrapper ${isMobile ? 'px-3' : ''}`}>
      <section className="py-4">
        <div className="custom-container">
          <Row className="course-page">
            <Col lg="3" md="4" sm="4" className="">
              <CourseSidebar
                loading={courseLoading}
                total={total}
                searchDrawer={searchDrawer}
                setSearchDrawer={setSearchDrawer}
                summary={summary && !courseLoading ? summary : courseSummary}
              />
            </Col>
            <Col lg="9" md="8" sm="8">
              <div className="course-items">
                {courseLoading ? (
                  <div className="text-center">
                    <Skeleton.Button className="text-center mb-2" active />
                  </div>
                ) : (
                  <>
                    {isMobile ? (
                      <div
                        className={`d-flex justify-content-start col-6 p-1 mb-4 cursor-pointer`}
                        onClick={() => setSearchDrawer(true)}
                      >
                        <img src="/images/sort.svg" width={'28px'} />
                        <h5
                          className={`text-center my-auto ml-2 text-dark ${
                            isGalaxyZFold ? 'font-size-sm' : ''
                          }`}
                        >
                          Filters
                        </h5>
                      </div>
                    ) : (
                      <h3
                        className="text-black font-size-middle text-center mb-3"
                        style={{ fontWeight: 'normal' }}
                      >
                        {total} results{' '}
                        {router?.query?.name &&
                          router?.query?.name !== undefined &&
                          `for  "${router?.query?.name}"`}
                      </h3>
                    )}
                  </>
                )}
                <Row>
                  {router?.isFallback ? (
                    <div style={{ top: '50%', left: '50%', position: 'absolute' }}>
                      <Loader />
                    </div>
                  ) : (
                    <CourseItemGrid total={total} loading={courseLoading} />
                  )}
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default memo(CourseGrid);
